module.exports = __webpack_public_path__ + "static/logo-a50875ef96f1d3ff7981f8c344e1458e.svg";